// components/NavigationSidebar.jsx
import { useState, useEffect } from 'react'
import {
  Home,
  BarChart3,
  Users,
  ContactRound,
  FileText,
  Menu,
  X,
  HelpCircle,
  LogOut,
} from 'lucide-react'
import Logo from '../../../assets/logo.png'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useUIStore } from '../../../store/useUIStore'
import { Link } from 'react-router-dom'

const NavigationSidebar = () => {
  const {
    activeMenu,
    setActiveMenu,
    isMobile,
    setIsMobile,
    isCollapsed,
    setIsCollapsed,
  } = useUIStore()
  // const [isCollapsed, setIsCollapsed] = useState(false);
  // const [isMobile, setIsMobile] = useState(false);

  const navigate = useNavigate()

  const toggleSidebar = () => setIsCollapsed(!isCollapsed)

  const toSignOut = () => {
    navigate('/logout')
    if (navigate) {
      toast.success('You have successfully signed out!', {
        position: 'top-right',
        autoClose: 3000,
        theme: 'colored',
      })
    }
  }

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768)
      if (window.innerWidth < 768) setIsCollapsed(true)
    }
    checkScreenSize()
    window.addEventListener('resize', checkScreenSize)
    return () => window.removeEventListener('resize', checkScreenSize)
  }, [])

  const menuItems = [
    { icon: Home, label: 'Home', href: '/dashboard/home' },
    { icon: BarChart3, label: 'Programs', href: '/dashboard/program' },
    { icon: Users, label: 'Clients', href: '/dashboard/client' },
    // { icon: ContactRound, label: 'Contacts', href: '/dashboard/contact' },
    // { icon: FileText, label: 'Documents', href: '/dashboard/document' },
  ]

  return (
    <>
      <div
        className={`bg-white border-r shadow-lg transition-all ${isMobile && !isCollapsed ? 'w-full' : ''} ${isCollapsed ? 'w-16' : 'w-64'} flex flex-col`}
      >
        {/* Header */}
        <div className="p-4 border-b">
          <div
            className={`flex items-center justify-center ${isMobile ? 'justify-between' : ''}`}
          >
            <div className=""></div>

            <div
              className={`flex items-center  ${isCollapsed ? 'justify-center' : ''}`}
            >
              <img className="w-10 h-12 rounded-lg" src={Logo} alt="Logo" />
              {/* {!isCollapsed && <h1 className="ml-3 text-lg font-semibold">Admin Panel</h1>} */}
            </div>
            <button
              onClick={toggleSidebar}
              className="rounded-lg hover:bg-gray-100 md:hidden"
            >
              {isCollapsed ? '' : <X />}
            </button>
          </div>
        </div>

        {/* Menu */}
        <nav className="flex-1 p-3">
          <ul className="space-y-1">
            {menuItems.map((item, i) => {
              const Icon = item.icon
              return (
                <li key={i}>
                  <Link to={item.href}>
                    <button
                      className={`flex w-full items-center px-3 py-2.5 rounded-lg ${
                        activeMenu === item.label
                          ? 'bg-blue-50 text-blue-600 border-r-2 border-blue-600'
                          : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
                      } ${isCollapsed ? 'justify-center' : ''}`}
                      onClick={() => setActiveMenu(item.label)}
                    >
                      <Icon className="w-5 h-5" />
                      {!isCollapsed && (
                        <span className="ml-3">{item.label}</span>
                      )}
                    </button>
                  </Link>
                </li>
              )
            })}
          </ul>
        </nav>

        {/* Bottom Menu */}
        <div className="border-t p-3">
          <button
            className="flex w-full items-center px-3 py-2.5 text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded-lg"
            onClick={() => {}}
          >
            <HelpCircle className="w-5 h-5" />
            {!isCollapsed && <span className="ml-3">Help</span>}
          </button>
          <button
            className="flex w-full items-center px-3 py-2.5 text-gray-600 hover:text-red-600 hover:bg-gray-50 rounded-lg"
            onClick={toSignOut}
          >
            <LogOut className="w-5 h-5" />
            {!isCollapsed && <span className="ml-3">Logout</span>}
          </button>
        </div>
      </div>
      {/* {isMobile && !isCollapsed && (
        <div className="fixed inset-0 z-40 md:hidden" onClick={toggleSidebar} />
      )} */}
    </>
  )
}

export default NavigationSidebar
